import React from "react";

import { Hero } from "../../Sections/Hero/Hero";
import { Beaches } from "../../Sections/Beaches/Beaches";
import { AboutLessons } from "../../Sections/AboutLessons/AboutLessons";
import { SurfPackages } from "../../Sections/SurfPackages/SurfPackages";
import { SurfExplanation } from "../../Sections/SurfExplanation/SurfExplanation";
import { PuertoBanner } from "../../Sections/PuertoBanner/PuertoBanner";
import { SaveTheWavesBanner } from "../../Components/SaveTheWavesBanner/SaveTheWavesBanner";

export const Home = () => {
  return (
    <>
      <Hero />
      <SurfExplanation />
      <Beaches />
      <PuertoBanner />
      <AboutLessons />
      <SurfPackages />
      <SaveTheWavesBanner />
    </>
  );
};
